import React from 'react';
import FullLogo from '../images/DAFullLogo.png';
import { ShieldAlert } from 'lucide-react';

function TokenExpired() {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <header className="sticky top-0 z-50 bg-slate-50/90 backdrop-blur-md border-b border-slate-200/60 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-start items-center h-16 sm:h-20">
                        <img src={FullLogo} alt="Data Aces" className="h-8 sm:h-10 w-auto object-contain" />
                    </div>
                </div>
            </header>
            
            <main className="flex-1 flex flex-col items-center justify-center p-4">
                <div className="bg-white border border-slate-200 shadow-sm rounded-3xl p-8 sm:p-12 max-w-lg w-full text-center flex flex-col items-center animate-in fade-in zoom-in duration-500">
                    <div className="w-[70px] h-[70px] bg-red-50 rounded-full flex items-center justify-center mb-6 border border-red-100 shadow-inner">
                        <ShieldAlert className="text-red-500 drop-shadow-sm" size={40} strokeWidth={2.5} />
                    </div>
                    <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-3 tracking-tight">Link Expired or Invalid</h1>
                    <p className="text-slate-500 text-sm sm:text-base mb-6 leading-relaxed">
                        Oops! It looks like this onboarding link is no longer valid or has expired. 
                        <br/><br/>
                        <span className="font-semibold text-slate-700">Please contact your HR representative for further process.</span>
                    </p>
                </div>
            </main>
        </div>
    );
}

export default TokenExpired;